import React from 'react';
import { UserCheck, Target, BarChart3, Calendar, Monitor, Users } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  UserCheck,
  Target,
  BarChart3,
  Calendar,
  Monitor,
  Users
};

const Services = () => {
  return (
    <section id="hizmetler" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Hizmetlerimiz</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-6">
            Size Özel Eğitim Çözümleri
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Her öğrencinin benzersiz olduğuna inanıyoruz. Kapsamlı hizmetlerimizle başarıya giden yolda yanınızdayız.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-gray-50 hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50 border border-transparent hover:border-gray-100"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-red-100 group-hover:bg-red-600 rounded-xl flex items-center justify-center mb-6 transition-all duration-300">
                  <Icon className="w-7 h-7 text-red-600 group-hover:text-white transition-colors" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Decoration */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-red-600/5 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
